import { Flex, Link, ListItem, UnorderedList } from '@chakra-ui/react';
import { Link as ReactRouterLink, useLocation } from 'react-router-dom';
import { CompassIcon } from '../iconComponents/CompassIcon';
import { FavoritesIcon } from '../iconComponents/FavoritesIcon';
import { SixesIcon } from '../iconComponents/SixesIcon';
import { StoreIcon } from '../iconComponents/StoreIcon';

export const handleMenuOpacity = (pathList: string[], currentPath: string) => {
    let opacity = '50%';
    pathList.forEach((p) => {
        if (currentPath.includes(p)) {
            opacity = '100%';
        }
    });
    return opacity;
};

export const MobileFooter = () => {
    const location = useLocation();
    return (
        <Flex className={'footer-component'}>
            <UnorderedList listStyleType="none" m={'0'} p={'0'} width={'100%'}>
                <Flex justifyContent={'space-evenly'}>
                    <ListItem>
                        <Link
                            as={ReactRouterLink}
                            to="/hosts"
                            opacity={handleMenuOpacity(['/hosts'], location.pathname)}
                        >
                            <CompassIcon />
                        </Link>
                    </ListItem>
                    <ListItem>
                        <Link
                            as={ReactRouterLink}
                            to="/following"
                            opacity={handleMenuOpacity(['/following'], location.pathname)}
                        >
                            <FavoritesIcon />
                        </Link>
                    </ListItem>
                    <ListItem>
                        <Link
                            as={ReactRouterLink}
                            to="/games"
                            opacity={handleMenuOpacity(['/games', '/game/'], location.pathname)}
                        >
                            <SixesIcon />
                        </Link>
                    </ListItem>
                    <ListItem>
                        <Link
                            as={ReactRouterLink}
                            to="/store"
                            opacity={handleMenuOpacity(['/store'], location.pathname)}
                        >
                            <StoreIcon />
                        </Link>
                    </ListItem>
                </Flex>
            </UnorderedList>
        </Flex>
    );
};
